import Chip from '@mui/material/Chip';
import { FC } from 'react';

export const OptionalChip: FC = () => (
  <Chip
    label="optional"
    size="small"
    variant="outlined"
    sx={{
      height: 20,
      fontSize: 11,
      fontWeight: 500,
      color: 'text.secondary',
      borderColor: 'divider',
    }}
  />
);

export const RequiredChip: FC = () => (
  <Chip
    label="required"
    size="small"
    variant="outlined"
    sx={{
      height: 20,
      fontSize: 11,
      fontWeight: 500,
    }}
  />
);
